import { clientOnlyLazy } from 'components/ClientOnlySuspense/clientOnlyLazy';
import LoadingModal from 'modals/LoadingModal';

export const GradProgramContactModalContainerLoadable = clientOnlyLazy({
  loader: () =>
    import(
      /* webpackChunkName: "GradProgramContactModalContainer" */
      './GradProgramContactModalContainer.dynamic'
    ),
  loading: LoadingModal,
});
